const monsters = require("../data/oprQuestArmy.json");
/**

i need a json file in the following format:
[{name:'', points:'', amount:''}]

for example:
4x Drained Soldiers [3] Q5+ D5+ | 25pts | Undead
3x Hand Weapon (A1)

would be:
[{name:'Drained Solder', points:'25', amount:'4'}]

*/
function getMonsters() {
  return monsters;
}

export function getMonstersForpoints({ points = 50 }) {
  const monsters = getMonsters();
  const result = selectMonsters({ creatures: monsters, targetpoints: points });
  return {
    ...result,
    monsters: sortMonstersByCreature(result.monsters),
  };
}

export function selectMonsters({ creatures, targetpoints, selectedMonsters = [], contador = 0 }) {
  // console.log({ creatures, targetpoints, selectedMonsters, contador });
  // Base case: Target threat level is reached or we ended up in a loop trying to find a valid monster,
  if (selectedMonsters.reduce((acc, monster) => acc + monster.points, 0) >= targetpoints || contador > 3000) {
    return {
      monsters: selectedMonsters,
      points_left: targetpoints - selectedMonsters.reduce((acc, monster) => acc + monster.points, 0),
      threat_final: selectedMonsters.reduce((acc, monster) => acc + monster.points, 0),
    };
  }

  // Randomly select an unvisited creature
  let randomIndex = Math.floor(Math.random() * creatures.length);

  const selectedCreature = creatures[randomIndex];
  selectedCreature.points = parseInt(selectedCreature.points);

  // Check if adding the creature's threat level would exceed the target
  const currentTotal = selectedMonsters.reduce((acc, monster) => acc + monster.points, 0);
  //console.log({ selectedCreature, currentTotal });
  if (currentTotal + selectedCreature.points > targetpoints || selectedCreature.amount <= selectedMonsters.filter((m) => m.name === selectedCreature.name).length) {
    // If it would exceed, skip this creature and try again
    return selectMonsters({ creatures, targetpoints, selectedMonsters, contador: contador + 1 });
  }

  // Recursively call the function with the updated visitedIndices and selectedMonsters array

  return selectMonsters({ creatures, targetpoints, selectedMonsters: [...selectedMonsters, selectedCreature], contador: contador + 1 });
}

export function sortMonstersByCreature(monsters) {
  return monsters.sort((a, b) => a.name.localeCompare(b.name));
}
